import { render, staticRenderFns } from "./BulkActionHelperText.vue?vue&type=template&id=20cebb3d&"
import script from "./BulkActionHelperText.vue?vue&type=script&lang=js&"
export * from "./BulkActionHelperText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports